export default __webpack_public_path__ + "static/media/premium-content.bdd222ec.png";